import { Navigate, Outlet, useParams } from "react-router-dom";

import { useGetOrg } from "@src/api/organizations/get-organization";
import { useSyncOrgFromUrl } from "@src/features/analytics/hooks/use-sync-org-from-url";
import { GENERAL_ROUTES } from "@src/routes/routes";

export const SitewideAnalyticsLayout = () => {
  const { id } = useParams<{ id?: string }>();
  const organization = useGetOrg();
  const orgId = organization.data?.org.id;

  useSyncOrgFromUrl();

  if (!id) {
    if (!orgId) {
      return null;
    }

    return (
      <Navigate to={`${GENERAL_ROUTES.SitewideAnalytics}/${orgId}`} replace />
    );
  }

  return <Outlet />;
};
